export const foldersDiagnosticDataDescription = "QkWzk";
export default {foldersDiagnosticDataDescription};